import React, { useState } from 'react'
import { Text, UploadLogo } from "../../formitems/Index";
import { LeftOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@apollo/client";
import { notification } from 'antd';
import { storage } from "../../../Firebase/firebase";
import { clients, insert_aatms_clients, update_aatms_clients, clients2 } from '../../../Queries/ClientQuery/clientQuery'

const Clients = () => {
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState("");
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [toggle, settoggle] = useState(true)
  const [openForm, setopenForm] = useState(false)
  const [currentFormData, setCurrentFormData] = useState({})
  const [Editclient, setEditclient] = useState(false)
  const [is_edit, setis_edit] = useState(true)
  const [clientNames, setclientNames] = useState("")
  const [clientdepartment, setclientdepartment] = useState("")
  const [headerrh1a, setheaderrh1] = useState('')
  const [headerrh2a, setheaderrh2] = useState('')
  const [landingmessage, setlandingmessage] = useState('')
  const [headerrh3a, setheaderrh3] = useState('')
  const [formfooter, setformfooter] = useState('')
  const [contactemail, setcontactemail] = useState('')
  const [contactperson_name, setcontactperson_name] = useState('')
  const [Mainmessage, setMainmessage] = useState('')
  const [Crewmessage, setCrewmessage] = useState('')
  const [Groundmessage, setGroundmessage] = useState('')
  const [Simulatormessage, setSimulatormessage] = useState('')
  const [Aircraftmessage, setAircraftmessage] = useState('')
  const [Managermessage, setManagermessage] = useState('')

  const edits = () => {
    setEditclient(true)
  }

  const { data } = useQuery(clients);
  const { data: dataa } = useQuery(clients2);
  const closeForm = () => {
    setopenForm(false)
    setEditclient(false)
  }


  const UpdateNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully ',
      description:
        `Successfully Update Client Thanks`,
    });
  };
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "clientname":
        setCurrentFormData({ ...currentFormData, clientname: v })
        break;
      case "department":
        setCurrentFormData({ ...currentFormData, department: v })
        break;
      case "headerrh1":
        setCurrentFormData({ ...currentFormData, headerrh1: v })
        break;
      case "headerrh2":
        setCurrentFormData({ ...currentFormData, headerrh2: v })
        break;
      case "headerrh3":
        setCurrentFormData({ ...currentFormData, headerrh3: v })
        break;
      case "footer":
        setCurrentFormData({ ...currentFormData, footer: v })
        break;
      case "date_formate":
        setCurrentFormData({ ...currentFormData, date_formate: v })
        break;
      case "contactemail":
        setCurrentFormData({ ...currentFormData, contactemail: v })
        break;
      case "contactperson":
        setCurrentFormData({ ...currentFormData, contactperson: v })
        break;
      case "crewmessage":
        setCurrentFormData({ ...currentFormData, crewmessage: v })
        break;
      case "mainmessage":
        setCurrentFormData({ ...currentFormData, mainmessage: v })
        break;
      case "managermessage":
        setCurrentFormData({ ...currentFormData, managermessage: v })
        break;
      case "aircraftmessage":
        setCurrentFormData({ ...currentFormData, aircraftmessage: v })
        break;
      case "landingmessage":
        setCurrentFormData({ ...currentFormData, landingmessage: v })
        break;
      case "groundmessage":
        setCurrentFormData({ ...currentFormData, groundmessage: v })
        break;
      case "simulatormessage":
        setCurrentFormData({ ...currentFormData, simulatormessage: v })
        break;
      case "logo":
        setCurrentFormData({ ...currentFormData, logo: v })
        break;
      default:
        break;
    }
  }
  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully Added Client',
      description:
        'Successfully Added Client Thank you.',
    });
  };
  const toggles = () => {
    if (toggle) {
      settoggle(false)
    }
    else {
      settoggle(true)
    }
  }
  const blanksform = () => {
    setclientNames("")
    setclientdepartment("")
    setheaderrh1("")
    setheaderrh2("")
    setheaderrh3("")
    setformfooter("")
    setcontactemail("")
    setcontactperson_name("")
    setMainmessage("")
    setCrewmessage("")
    setGroundmessage("")
    setSimulatormessage("")
    setAircraftmessage("")
    setManagermessage("")
  }

  const [updateClient, { data: newData }] = useMutation(update_aatms_clients, {
    refetchQueries: [{ query: clients }]
  })
  const [inserClient, { data: datas }] = useMutation(insert_aatms_clients, {
    refetchQueries: [{ query: clients }]
  })

  const handChange = e => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/gif", "image/jpeg", "image/png","image/svg"];
      if (validImageTypes.includes(fileType)) {
        setError("");
        setImage(file);
        setUrl("")
      } else { 
        setError("Please select an image to upload");
      }
    }
  };

  const handleUpdate = () => {
    if (image) {
      const uploadTask = storage.ref(`logo/${image.name}`).put(image);

      uploadTask.on(
        "state_changed",
        snapshot => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progress);
        },
        error => {
          setError(error);
        },
        () => {
          storage
            .ref("logo")
            .child(image.name)
            .getDownloadURL()
            .then(url => {
              setUrl(url);
              setProgress(0);
            });
        }
      );
    } else {
      setError("Error please choose an image to upload");
    }
  };
  return (
    <div className="animate__animated animate__fadeIn">
      <div
        className={
          "category-title " + (openForm || Editclient ? "hide-element" : "")
        } >
        Clients
        </div>
      {/* Client listing code */}
      <div
        className={
          "clients-container " + (openForm || Editclient ? "hide-element" : "")
        }
      >
        <button
          onClick={() => {
            edits()
            blanksform()
          }}
          className="add-new-client-button"
        >
          Add New Client
          </button>
        <div className="clients-list">
          <div className="clients-list-header">Manage Existing Clients</div>

          <ul>
            {toggle ? data?.aatmsv4_clients?.map((el, i) => (
              <li key={i}
                className="client-list-item"
                onClick={() => {
                  setCurrentFormData(el)
                  setopenForm(!openForm)
                  setis_edit(true)
                }} >
                <img className="client-logo" src={el.logo} alt=""></img>
                <div className="client-name">{el.clientname}</div>
              </li>
            )) : dataa?.aatmsv4_clients?.map((el, i) => (
              <li key={i}
                className="client-list-item"
                onClick={() => {
                  setCurrentFormData(el)
                  setopenForm(!openForm)
                  setis_edit(true)
                }} >
                <img className="client-logo" src={el.logo} alt=""></img>
                <div className="client-name">{el.clientname}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Add client */}
      <div
        className={
          "category-title " + (Editclient ? "" : "hide-element")
        }
      >
        <span className="client-back" onClick={() => closeForm()}>
          {<LeftOutlined />} CLIENT
          </span>
         Add New Client
        </div>
      <div className={"toggle-form-container " + (Editclient ? "" : "hide-element")} >
        <Text title="Client Name" character_limit={true} max_character="40" value={clientNames} onChange={(e) => setclientNames(e.target.value)} />
        <Text title="Client department" value={clientdepartment} onChange={(e) => setclientdepartment(e.target.value)} />
        <Text title="Header RH1" value={headerrh1a} onChange={(e) => setheaderrh1(e.target.value)} />
        <Text title="Header RH2" value={headerrh2a} onChange={(e) => setheaderrh2(e.target.value)} />
        <Text title="Header RH3" value={headerrh3a} onChange={(e) => setheaderrh3(e.target.value)} />
        <Text title="Form Footer" value={formfooter} onChange={(e) => setformfooter(e.target.value)} />
        <Text title="Contact Person Name" value={contactperson_name} onChange={(e) => setcontactperson_name(e.target.value)} />
        <Text title="Contact Email" value={contactemail} onChange={(e) => setcontactemail(e.target.value)} />
        <Text title="Main message" value={Mainmessage} onChange={(e) => setMainmessage(e.target.value)} />
        <Text title="Landing message" value={landingmessage} onChange={(e) => setlandingmessage(e.target.value)} />
        <Text title="Crew message" value={Crewmessage} onChange={(e) => setCrewmessage(e.target.value)} />
        <Text title="Ground message" value={Groundmessage} onChange={(e) => setGroundmessage(e.target.value)} />
        <Text title="Simulator message" value={Simulatormessage} onChange={(e) => setSimulatormessage(e.target.value)} />
        <Text title="Aircraft message" value={Aircraftmessage} onChange={(e) => setAircraftmessage(e.target.value)} />
        <Text title="Manager message" value={Managermessage} onChange={(e) => setManagermessage(e.target.value)} />
        <div>
          <input type="file" style={{ backgroundColor: 'beige', borderRadius: '25px' }} onChange={handChange}  />
         {!url ? <button className="cancel-button" onClick={handleUpdate}>Save</button> : null} 
        </div>
        {!url ? null : (
        <div>
          <button className="submit-button" onClick={() => {
            inserClient({
              variables: {
                logo: url,
                clientname: clientNames,
                department: clientdepartment,
                headerrh1: headerrh1a,
                headerrh2: headerrh2a,
                headerrh3: headerrh3a,
                footer: formfooter,
                contactemail: contactemail,
                contactperson: contactperson_name,
                crewmessage: Crewmessage,
                mainmessage: Mainmessage,
                managermessage: Managermessage,
                aircraftmessage: Aircraftmessage,
                simulatormessage: Simulatormessage,
                groundmessage: Groundmessage,
                landingmessage: landingmessage
              }
            })
            setUrl("")
            closeForm()
            openNotificationWithIcon('success')
          }}>
            Add Client
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
        )}
      </div>

      {/* Update client form */}
      <div
        className={
          "category-title " + (openForm ? "" : "hide-element")
        }
      >
        <span className="client-back" onClick={() => closeForm()}>
          {<LeftOutlined />} CLIENTS
          </span>
        Manage Existing Clients
      </div>
      <div
        className={
          "toggle-form-container " +
          (openForm ? "" : "hide-element")
        } >
        <Text title="Client Name" character_limit={true} max_character="40" value={currentFormData?.clientname} onChange={(e) => handleFormFields(e.target.value, "clientname")} />
        <Text title="Client department" value={currentFormData?.department} onChange={(e) => handleFormFields(e.target.value, "department")} />
        <Text title="Header RH1" value={currentFormData?.headerrh1} onChange={(e) => handleFormFields(e.target.value, "headerrh1")} />
        <Text title="Header RH2" value={currentFormData?.headerrh2} onChange={(e) => handleFormFields(e.target.value, "headerrh2")} />
        <Text title="Header RH3" value={currentFormData?.headerrh3} onChange={(e) => handleFormFields(e.target.value, "headerrh3")} />
        <Text title="Form Footer" value={currentFormData?.footer} onChange={(e) => handleFormFields(e.target.value, "footer")} />
        <Text title="Contact Person Name" value={currentFormData?.contactperson} onChange={(e) => handleFormFields(e.target.value, "contactperson")} />
        <Text title="Contact Email" value={currentFormData?.contactemail} onChange={(e) => handleFormFields(e.target.value, "contactemail")} />
        <Text title="Crew message" value={currentFormData?.crewmessage} onChange={(e) => handleFormFields(e.target.value, "crewmessage")} />
        <Text title="Landing message" value={currentFormData?.landingmessage} onChange={(e) => handleFormFields(e.target.value, "landingmessage")} />
        <Text title="Ground message" value={currentFormData?.groundmessage} onChange={(e) => handleFormFields(e.target.value, "groundmessage")} />
        <Text title="Simulator message" value={currentFormData?.simulatormessage} onChange={(e) => handleFormFields(e.target.value, "simulatormessage")} />
        <Text title="Aircraft message" value={currentFormData?.aircraftmessage} onChange={(e) => handleFormFields(e.target.value, "aircraftmessage")} />
        <Text title="Manager message" value={currentFormData?.managermessage} onChange={(e) => handleFormFields(e.target.value, "managermessage")} />
        <div>
          <input type="file" style={{ backgroundColor: 'beige', borderRadius: '25px' }} onChange={handChange} />
         {!url ? <button className="cancel-button" onClick={handleUpdate}>Save</button> : null} 
        </div>
        {!url ? null : (
          <div>
            <button className="submit-button"
              onClick={() => {
                updateClient({
                  variables: {
                    logo: url,
                    id: currentFormData.clientsid,
                    clientname: currentFormData.clientname,
                    department: currentFormData.department,
                    headerrh1: currentFormData.headerrh1,
                    headerrh2: currentFormData.headerrh2,
                    headerrh3: currentFormData.headerrh3,
                    footer: currentFormData.footer,
                    contactemail: currentFormData.contactemail,
                    contactperson: currentFormData.contactperson,
                    crewmessage: currentFormData.crewmessage,
                    landingmessage: currentFormData.landingmessage,
                    managermessage: currentFormData.managermessage,
                    aircraftmessage: currentFormData.aircraftmessage,
                    simulatormessage: currentFormData.simulatormessage,
                    groundmessage: currentFormData.groundmessage
                  }
                })
                setUrl("")
                closeForm()
                UpdateNotificationWithIcon('success')
              }} >
              Update
        </button>
            <button onClick={() => closeForm()} className="cancel-button">
              Cancel
          </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Clients
